import { Button } from "antd";
import { useCallback, useRef } from "react";
import * as XLSX from 'xlsx';
import { CloudDownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import moment from "moment";

export default function Table2XLSX({ month, revenueInfo, dataSource = [], shopInfo }) {
    const { t } = useTranslation()
    const tableRef = useRef(null);

    /* Callback invoked when the button is clicked */
    const xport = useCallback(async () => {
        /* Create worksheet from HTML DOM TABLE */
        const table = tableRef?.current;
        const wb = XLSX.utils.table_to_book(table);

        /* Export to file (start a download) */
        XLSX.writeFile(wb, `${t('revenueInMonth', { month })}.xlsx`);
    }, []);

    return (<>
        <table ref={tableRef} style={{ display: 'none' }} >
            <tbody>
                <tr style={{ backgroundColor: 'red' }}>
                    <td colSpan={8 + revenueInfo.cabinet * 2}>{t('revenueInMonth', { month })}</td>
                </tr>
                <tr>
                    <td rowSpan={2}>{t('day')}</td>
                    <td rowSpan={2}>{t('dow')}</td>
                    <td colSpan={1 + revenueInfo.cabinet}>{t('produce')}</td>
                    <td colSpan={1 + revenueInfo.cabinet}>{t('revenueAfterTax')}</td>
                    <td rowSpan={2}>{t('superMarket')}</td>
                    <td rowSpan={2}>{t('qsl')}</td>
                    <td rowSpan={2}>{t('cityFood')}</td>
                    <td rowSpan={2}>{t('%wasteBoxShop')}</td>
                </tr>
                <tr>
                    <td>{shopInfo.shopCode || t('shop')}</td>
                    {revenueInfo.cabinet > 0 && shopInfo?.cabinet_code_1 ? shopInfo.cabinet_code_1 : <td>{t('cabinet', { value: 1 })}</td>}
                    {revenueInfo.cabinet > 1 && shopInfo?.cabinet_code_2 ? shopInfo.cabinet_code_2 : <td>{t('cabinet', { value: 2 })}</td>}
                    <td>{shopInfo.shopCode || t('shop')}</td>
                    {revenueInfo.cabinet > 0 && shopInfo?.cabinet_code_1 ? shopInfo.cabinet_code_1 : <td>{t('cabinet', { value: 1 })}</td>}
                    {revenueInfo.cabinet > 1 && shopInfo?.cabinet_code_2 ? shopInfo.cabinet_code_2 : <td>{t('cabinet', { value: 2 })}</td>}
                </tr>
                {
                    dataSource.map((row, index) => {
                        return (
                            <tr>
                                <td>{index + 1}</td>
                                <td>{t(moment(row.date).format('dddd'))}</td>
                                <td>{row?.morningShift || row?.noonShift}</td>
                                {revenueInfo.cabinet > 0 && <td>{row?.produceCabinet1}</td>}
                                {revenueInfo.cabinet > 1 && <td>{row?.produceCabinet2}</td>}
                                <td>{row?.revenue}</td>
                                {revenueInfo.cabinet > 0 && <td>{row?.revenueCabinet1}</td>}
                                {revenueInfo.cabinet > 1 && <td>{row?.revenueCabinet2}</td>}
                                <td>{row?.superMarket}</td>
                                <td>{row?.qsl}</td>
                                <td>{row?.cityFood}</td>
                                <td>{row?.wasteBoxShopPercent ? `${row.wasteBoxShopPercent}%` : ''}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
        <Button type='primary' size="large" icon={<CloudDownloadOutlined />} onClick={xport}>{t('exportExcel')}</Button>
    </>);
}